//imports
import React, { useEffect, useState } from "react";
import {
  Box,
  AppBar,
  Grid,
  Stack,
  Autocomplete,
  TextField,
  CircularProgress,
  Breadcrumbs,
  Link,
  Button,
  Chip,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { externalgetApi } from "../../services/external/externalApis";
import { ORDER_API_03 } from "../../api/ApiModel";
import {
  CON_ORDER_STATUS_LIST,
  CON_STATUS_ACTIVE,
  CON_STATUS_DELETED,
  CON_STATUS_PENDING,
  CON_STATUS_RETURN,
  CON_ORDER_RETURN,
  CON_ORDER_REFUND,
  CON_ORDER_EXCHANGE,
  CON_ORDER_CANCEL,
  CON_ORDER_VOID,
  CON_STATUS_ALL,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import Navbar from "../../components/common/Navbar";
import ViewData from "../../components/grids/ViewDatagrid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { Orderlistdata } from "../../assets/Griddata";
import { useStyles } from "../../assets/styles/Theme";
import { currencyFormatLKR } from "../../utils/common/CurrencyFormat";
import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import CurrencyExchangeRoundedIcon from "@mui/icons-material/CurrencyExchangeRounded";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ListSearchBar from "../../components/common/listSearch";

//hooks
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");

const startOfMonth = dayjs().startOf("month");

const endOfMonthDate = dayjs().endOf("month");
function OrderList() {
  //hooks
  const [orderData, setOrderData] = useState([]);
    const [filteredData, setFilteredData] = useState(null);
  
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState({
    ORDERSTATUSCODE: CON_ORDER_STATUS_LIST[0].ORDERSTATUSCODE,
    ORDERSTATUSNAME: CON_ORDER_STATUS_LIST[0].ORDERSTATUSNAME,
  });
  const [fromDate, setFromDate] = useState(startOfMonth);
  const [toDate, setToDate] = useState(endOfMonthDate);
  const [searchText, setSearchText] = useState("");

  const navigate = useNavigate();
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  const orderStatuses = CON_ORDER_STATUS_LIST;

  const theme = useTheme();
  const styles = useStyles(theme);

  useEffect(() => {
    if (selectedStatus?.ORDERSTATUSCODE) {
      fetchOrderData(selectedStatus.ORDERSTATUSCODE);
    }
  }, [selectedStatus, fromDate, toDate]);

   useEffect(() => {
      if (orderData) {
        const filtered = orderData.filter((item) => {
          const INVNO = String(item.INVNO);
          return (
            INVNO.toLowerCase().includes(searchText.toLowerCase()) ||
            item.INVNO.toString().toLowerCase().includes(searchText.toLowerCase())
          );
        });
        setFilteredData(filtered);
      }
    }, [searchText, orderData]);

  const handleDateChange = (newValue) => {
    if (newValue) {
      // Format the date to YYYY-MM-DD before sending to API
      const formattedDate = newValue.format("MM/DD/YYYY");
      setFromDate(dayjs(formattedDate));
    } else {
      setFromDate(""); // Handle null case
    }
  };

  const handleToDateChange = (newValue) => {
    if (newValue) {
      // Format the date to YYYY-MM-DD before sending to API
      const formattedDate = newValue.format("MM/DD/YYYY");
      setToDate(dayjs(formattedDate));
    } else {
      setToDate(""); // Handle null case
    }
  };
const fetchOrderData = async (statusCode) => {
  setLoading(true);

  let stsValue;

  switch (statusCode) {
    case CON_STATUS_ALL:
      stsValue = CON_STATUS_ALL;
      break;
    case CON_STATUS_ACTIVE:
      stsValue = CON_STATUS_ACTIVE;
      break;
    case CON_STATUS_PENDING:
      stsValue = CON_STATUS_PENDING;
      break;
    case CON_STATUS_DELETED:
      stsValue = CON_STATUS_DELETED;
      break;
    default:
      stsValue = CON_STATUS_RETURN;
  }

  const params = {
    COMPCODE,
    LOCCODE,
    RESTCODE,
    FROMDATE: dayjs(fromDate).format("MM-DD-YYYY"),
    TODATE: dayjs(toDate).format("MM-DD-YYYY"),
    STS: stsValue,
  };

  try {
    const response = await externalgetApi(
      ORDER_API_03,
      "GET",
      params
    );

    // Exclude cancelled orders from the Return Orders list
    const filteredOrders = (response || []).filter(
      (item) => item.STS !== CON_STATUS_DELETED
    );

    setOrderData(filteredOrders);
    setFilteredData(filteredOrders);
  } catch (err) {
    console.error("Failed to fetch order data:", err);
    setOrderData([]);
    setFilteredData([]);
  } finally {
    setLoading(false);
  }
};

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      INVNO: item.INVNO,
      ORDERCODE: item.ORDERCODE,
      ORDERENDATE: item.ORDERENDATE,
      ENUSER: item.ENUSER,
      STSCODE: item.STS,
      STS:
        item.STS === CON_STATUS_ACTIVE ? (
          <Chip label="Paid" variant="filled" color="success" />
        ) : item.STS === CON_STATUS_PENDING ? (
          <Chip label="Orders" variant="filled" color="warning" />
        ) : item.STS === CON_STATUS_DELETED ? (
          <Chip label="Cancelled" variant="filled" color="error" />
        ) : item.STS === CON_STATUS_RETURN ? (
          <Chip label="Returned" variant="filled" color="primary" />
        ) : null,

      AMOUNT: currencyFormatLKR(item.AMOUNT, "LKR", false),
    }));
  };
  //handlers
  const handleStatusChange = (status) => {
    setSelectedStatus(status);
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  // const handleStatusChange = (newValue) => {
  //   if (newValue) {
  //     setSelectedStatus(newValue);
  //   } else {

  //     setSelectedStatus(null);
  //     setOrderData([]);
  //   }
  // };

  const handleItemClick = (ORDERCODE, actionText) => {
    const selectedItem = orderData.find((item) => item.ORDERCODE === ORDERCODE);
    if (selectedItem) {
      navigate(`/ordercancel`, {
        state: { selectedItem, actionText, ORDERCODE },
      });
    }
  };

  const handleItemClick1 = (ORDERCODE, actionText) => {
    const selectedItem = orderData.find((item) => item.ORDERCODE === ORDERCODE);
    if (selectedItem) {
      navigate(`/orderreturn`, {
        state: { selectedItem, actionText, ORDERCODE },
      });
    }
  };

  const completedMenuItems = [
    {
      text: "Return",
      icon: <ReplayOutlinedIcon />,
      onClick: (ORDERCODE) => handleItemClick1(ORDERCODE, CON_ORDER_RETURN),
    },
    {
      text: "Refund",
      icon: <AttachMoneyOutlinedIcon />,
      onClick: (ORDERCODE) => handleItemClick1(ORDERCODE, CON_ORDER_REFUND),
    },
    {
      text: "Exchange",
      icon: <SwapHorizOutlinedIcon />,
      onClick: (ORDERCODE) => handleItemClick1(ORDERCODE, CON_ORDER_EXCHANGE),
    },
    {
      text: "Void",
      icon: <ClearOutlinedIcon />,
      onClick: (ORDERCODE) => handleItemClick1(ORDERCODE, CON_ORDER_VOID),
    },
  ];

  const placedMenuItems = [
    {
      text: "Cancel",
      icon: <ClearOutlinedIcon />,
      onClick: (ORDERCODE) => handleItemClick(ORDERCODE, CON_ORDER_CANCEL),
    },
  ];

  const menuItems = (row) => {
    const sts = row?.STSCODE;
    if (sts === CON_STATUS_ACTIVE) return completedMenuItems;
    if (sts === CON_STATUS_PENDING) return placedMenuItems;
    return [];
  };

  return (
    <>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                sx={styles.AI_breadcrumbs2}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Returns</Link>
                <Link underline="none">Order List</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item p={2}>
              <Stack
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
                sx={styles.AI_fixedStack1}
              ></Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.OL_AddStyledBox}>
        {/* <Grid container spacing={1}> */}
        {/* First Row: Back Button */}

        {/* Second Row: Select Location, From Date, To Date, Report Button */}
        <Grid
          container
          spacing={2}
          mr={15}
          sx={styles.OL_AddStyledBox_container}
        >
          <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={handleDateChange}
                inputFormat="MM/DD/YYYY"
                slotProps={{
                  textField: {
                    sx: {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={handleToDateChange}
                inputFormat="MM/DD/YYYY"
                slotProps={{
                  textField: {
                    sx: {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <Autocomplete
              value={selectedStatus}
              onChange={(event, newValue) => handleStatusChange(newValue)}
              options={orderStatuses}
              getOptionLabel={(option) => option.ORDERSTATUSNAME || ""}
              isOptionEqualToValue={(option, value) =>
                option.ORDERSTATUSCODE === value?.ORDERSTATUSCODE
              }
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Order Status"
                  variant="outlined"
                  size="small"
                  // fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      // height: "43px",
                      minWidth: "200px",
                      // maxWidth: 600,
                    },
                  }}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 180,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={5} p={2}>
              <ListSearchBar onChange={handleSearchChange} value={searchText} />
          </Grid>
        </Grid>
        {/* </Grid> */}
      </Box>
      <Box sx={styles.OL_vdg}>
        {loading ? (
          <CircularProgress />
        ) : (
          <ViewData
            columns={Orderlistdata.columns}
            rows={mapResultToRows(filteredData)}
            menuItems={menuItems}
            tabletitle={Orderlistdata.name}
            gridid="ORDERCODE"
          />
        )}
      </Box>
    </>
  );
}

export default OrderList;
